import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { iconActions } from '../iconActions';
import IconBox from '../Iconbox';
import IconboxFanchart from '../IconboxFanchart';
import { toUpper, shrinkWordsWidth } from '../../../library/calc';
import { isDevelopment} from '../../../library/constants';
import assets from '../../../containers/tree/assets';

class Icons extends Component {

  componentDidMount(){
    if(isDevelopment && typeof(this.refs['moreIcon']) !== 'undefined') {

    }
  }

  shouldComponentUpdate( props ){
  }


  // componentDidUpdate (prevProps, prevState, snapshot){

  //   console.log('componentDidUpdate');
  //   clearTimeout(this.thatTimeOut);
  //   this.thatTimeOut = setTimeout(() => {
  //     console.log('FOO last');
  //   }, 800);

  // }

  render () {

    const {
      iconsContainerWidth,
      iconBoxSide,
      toggleMoreList,
      hideMoreList,
      nodeForFlipFocus,
      nodeObjs,
      reloadWithNewTree,
      refocusFanChart,
      toggleFlipPanel,
      setPushToHistory,
      showTreeOverlay,
      stopStageClickPropagation,
      flipData,
      translatedLabels,
      onclickedAddNodeTab,
      setPedigreeAddbox,
      hideProductTour,
      showProgressIndicator,
      fetchIsLoading,
      showHookMessageForNearbyTreeMatches,
      showHookMessageNeedForReload,
    } = this.props;

    if (typeof(translatedLabels) === 'undefined') { return null;}

    const IconBoxWrapper = styled.div`
      clear: both;
      top: 26px;
      position: relative;
    `;

    let hasMoreAdd = undefined;
    if(nodeForFlipFocus && typeof(nodeObjs[nodeForFlipFocus]) !== 'undefined' ){
      hasMoreAdd = nodeObjs[nodeForFlipFocus].hasMoreAdd;
    }

    const maxLength = 10;
    const iconActionArray = [...iconActions, ...[
    {
      imgFile: `node/tree.svg`,
      engLabel: 'tree',
      label: shrinkWordsWidth({word: toUpper(translatedLabels.tree.translatedLabel), maxLength}),
      action: (pr_id) => {
        hideProductTour({fromWhere: 'iconJs', withLastStepNotify: true, skipGotoFocus: true});
        setTimeout(() => {
          const prId = pr_id;
          const node = nodeObjs.n;
          if(this.props.chartType === 'fan'){
            this.props.refocusFanChart({prId});
            return;
          }
          toggleFlipPanel({close: true, from: 'icon'});
          setPedigreeAddbox({visible: false});
          setPushToHistory();
          reloadWithNewTree({prId, node, fromWhere: 'Icons'});
        }, 800);
      },
      ref: 'treeIcon',
      imgDomElement: assets.treeChartImage
    },
    {
      imgFile: `flip/edit.svg`,
      engLabel: 'edit',
      label: shrinkWordsWidth({word: toUpper(translatedLabels.edit.translatedLabel), maxLength}),
      action: (pr_id) => {
        if(isDevelopment){ alert('You are on Development.');return;};
        hideProductTour({fromWhere: 'iconJs', withLastStepNotify: true, skipGotoFocus: true});
        hideMoreList();
        showProgressIndicator();
        showTreeOverlay();
        window.openEditCard(pr_id);
      },
      ref: 'editIcon',
      imgDomElement: assets.editImage
    },
    {
      imgFile: `flip/add.svg`,
      engLabel: 'add',
      label: shrinkWordsWidth({word: toUpper(translatedLabels.add.translatedLabel), maxLength}),
      action: (pr_id, n) => {


        if(typeof(hasMoreAdd) !== 'undefined' && hasMoreAdd){
          showHookMessageNeedForReload();
        } else {
          hideMoreList();
          onclickedAddNodeTab(n);
        }


      },
      ref: 'addIcon',
      imgDomElement: assets.addImage
    },
    {
      imgFile: `flip/more.svg`,
      engLabel: 'more',
      label: shrinkWordsWidth({word: toUpper(translatedLabels.more.translatedLabel), maxLength}),
      action: () => {
        // console.log('toggling');
        toggleMoreList();
      },
      ref: 'moreIcon',
      imgDomElement: assets.ellipsesImage
    },
    ]];


    const iconActionFanchartArray = [...[
    {
      imgFile: `node/tree.svg`,
      engLabel: 'tree',
      label: shrinkWordsWidth({word: toUpper(translatedLabels.tree.translatedLabel), maxLength}),
      action: (pr_id) => {

      },
      ref: 'treeIcon',
      imgDomElement: assets.treeChartImage
    },
    {
      imgFile: `flip/edit.svg`,
      engLabel: 'edit',
      label: shrinkWordsWidth({word: toUpper(translatedLabels.edit.translatedLabel), maxLength}),
      action: (pr_id) => {
      },
      ref: 'editIcon',
      imgDomElement: assets.editImage
    },
    {
      imgFile: `flip/add.svg`,
      engLabel: 'add',
      label: shrinkWordsWidth({word: toUpper(translatedLabels.add.translatedLabel), maxLength}),
      action: (pr_id, n) => {
      },
      ref: 'addIcon',
      imgDomElement: assets.addImage
    },
    {
      imgFile: `flip/more.svg`,
      engLabel: 'more',
      label: shrinkWordsWidth({word: toUpper(translatedLabels.more.translatedLabel), maxLength}),
      action: () => {
      },
      ref: 'moreIcon',
      imgDomElement: assets.ellipsesImage
    },
    ]];


    let idx = -1;

    const IconBoxes = iconActionArray.map((iconAction)=>{
      idx++;
      return <IconBox
        key={idx}
        idx={idx}
        ref={iconAction.ref}
        imgFile={iconAction.imgFile}
        label={iconAction.label}
        translatedLabels={translatedLabels}
        engLabel={iconAction.engLabel}
        imgDomElement={iconAction.imgDomElement}
        action={iconAction.action}
        iconsContainerWidth={iconsContainerWidth}
        flipData={flipData}
        fetchIsLoading={fetchIsLoading}
        iconBoxSide={iconBoxSide}
        nodeForFlipFocus={nodeForFlipFocus}
        stopStageClickPropagation={stopStageClickPropagation}
        showHookMessageForNearbyTreeMatches={showHookMessageForNearbyTreeMatches}
        showHookMessageNeedForReload={showHookMessageNeedForReload}
        refocusFanChart={refocusFanChart}
        nodeObjs={nodeObjs}
      />;
    })

    const IconFanchartBoxes = iconActionFanchartArray.map((iconAction)=>{
      idx++;
      return <IconboxFanchart
        key={idx}
        idx={idx}
        ref={iconAction.ref}
        imgFile={iconAction.imgFile}
        label={iconAction.label}
        translatedLabels={translatedLabels}
        engLabel={iconAction.engLabel}
        imgDomElement={iconAction.imgDomElement}
        action={iconAction.action}
        iconsContainerWidth={iconsContainerWidth}
        flipData={flipData}
        fetchIsLoading={fetchIsLoading}
        iconBoxSide={iconBoxSide}
        nodeForFlipFocus={nodeForFlipFocus}
        stopStageClickPropagation={stopStageClickPropagation}
        showHookMessageForNearbyTreeMatches={showHookMessageForNearbyTreeMatches}
        showHookMessageNeedForReload={showHookMessageNeedForReload}
        nodeObjs={nodeObjs}
      />;
    })

    return (
      <Fragment>
          <IconBoxWrapper>
            {IconBoxes}
          </IconBoxWrapper>

          {  this.props.isFanChart

              ?
/*

          <IconBoxWrapper>
            {IconFanchartBoxes}
          </IconBoxWrapper>
 */

            null
              :

            null

          }
      </Fragment>
    );
  }
};

export default Icons;
